// src/components/Layout.js
import React from 'react';
import { Outlet } from 'react-router-dom';
import TopBar from './TopBar';
import Footer from './Footer'; 

const Layout = () => {
    return (
        <div className="layout-wrapper">
            <TopBar />
            <main className="container">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;